module.exports = __webpack_public_path__ + "static/media/landingImage1.aff78efb.png";